import "containers/common/List.css";
import Moment from "moment";
import React, { Component } from "react";
import { Alert, Button, Col, Form, ListGroup, Modal, Row } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { LinkContainer } from "react-router-bootstrap";
import ReactTable from "react-table";
import 'react-table/react-table.css';



export default class SaleList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            searching: false,
            isLoading: true,
            sales: [],
            filter: {},
            dataSet: "propertySales",
            dataRecord: "propertySales",
            dataSetPrimaryKey: "property_sale_id",
            showAlert: false,
            errorMessage: "",
            savingNewRecord: false,
            last_sale_index: null,
            
        };

        this.handleDeleteRecord = this.handleDeleteRecord.bind(this);
    }
    

    async componentDidMount() {
      
        if (!this.props.isAuthenticated) { // if false
            return;
        }
        if(this.props.userPermissions){
            console.log("In witholding list and have user permissions props")
            if(this.props.userPermissions.trust_proof){
                this.setState({trust_proof:true})
            }
            else{
                this.setState({trust_proof:false})
            }
        }


        this.setState({ isLoading: false });      
    }

    async componentDidUpdate(prevProps){
        if(prevProps.userPermissions !== this.props.userPermissions)
            {
            if(this.props.userPermissions){
                console.log("In witholding list and have user permissions props")
                if(this.props.userPermissions.trust_proof){
                    this.setState({trust_proof:true})
                }
                else{
                    this.setState({trust_proof:false})
                }
            }
        }
    }


    async handleDataSave(data) {
        try {
            return await this.props.saveRecord(data, this.state.dataSet, this.state.dataSetPrimaryKey);



        } catch (e) {
            alert("Error saving");
        }
    }



    handleDeleteRecord = async (cellInfo, event) => {
        event.preventDefault();
        console.log("delete address");
        
        
        var r = window.confirm("Are you sure you want to delete this record?");
        if (r === true) {
            console.log(cellInfo);
            if (this.state.last_sale_index === cellInfo.index) {
                this.setState(state => ({ last_sale_index: null }));
            }
            let data = [...this.props.data];
            data[cellInfo.index].archived_date = new Date();
            await this.handleDataSave(data[cellInfo.index]).then((result) => {
                data.splice(cellInfo.index, 1);
                this.props.updateTableState(data, this.state.dataSet);
                if(this.props.controlType !== "table2"){
                    this.calculateLastSale();
                }
            }
            )
        };
    };


    handleInputChange = (cellInfo, event) => {
        console.log(typeof (event.target.value));
        let data = [...this.props.data];
        if(cellInfo.column.id==="property_key"){
            data[cellInfo.index][cellInfo.column.id] = event.target.value.toUpperCase();
        }
        else{
            data[cellInfo.index][cellInfo.column.id] = event.target.value;
        }
        data[cellInfo.index].modified = true;
        this.props.updateTableState(data, this.state.dataSet);
    };
    handleNumberChange = (cellInfo, event) => {
        let data = [...this.props.data];
        let val = event.target.value.replace(/[^0-9]/g, "");
        
        data[cellInfo.index][cellInfo.column.id] = val;
        data[cellInfo.index].modified = true;
        this.props.updateTableState(data, this.state.dataSet);
    };
    handleCheckboxChange = (cellInfo, event) => {
        let data = [...this.props.data];
        data[cellInfo.index][cellInfo.column.id] = event.target.checked;
        data[cellInfo.index].modified = true;
        this.props.updateTableState(data, this.state.dataSet);
        console.log("In handle checkbox change");
       
        if (cellInfo.column.id === "last_sale") {
            console.log("Setting last sale index");
            if (event.target.checked) {
                this.setState({ last_sale_index: cellInfo.index });
            }
            else {
                this.setState({ last_sale_index: null });
            }
        }
    };

    handleDateChange = (cellInfo, event) => {
        let data = [...this.props.data];
        data[cellInfo.index][cellInfo.column.id] = new Date(event);
        data[cellInfo.index].modified = true;
        this.props.updateTableState(data, this.state.dataSet);

    }

    async calculateLastSale() {
        let data = [...this.props.data];

        //if the user has set last_sale, take that otherwise use the last sale date
        console.log("In calculate last sale");
        console.log(this.state.last_sale_index);

        if (this.state.last_sale_index===null)
        {
            let last_sale_date = null;
            console.log("Using calculated last sale flag");
            //Work out the last sale
            for (var i = 0; i < data.length; i++) {
                if ((new Date(data[i].sale_date)).getTime() > (new Date(last_sale_date)).getTime() || !last_sale_date) {
                    if (data[i].archived_date) {
                        continue;
                    }
                    else {
                        last_sale_date = new Date(data[i].sale_date);
                    }
                }
            };
            console.log(last_sale_date);
            for (var i = 0; i < data.length; i++) {
                console.log(new Date(data[i].sale_date));
                if ((new Date(data[i].sale_date)).getTime() === last_sale_date.getTime()) {
                    console.log("Dates are equal");
                    if (!data[i].last_sale) {
                        data[i].last_sale = true;
                        let result = await this.handleDataSave(data[i]);
                        console.log(result);
                        if (!result.result) {
                            this.setState({ errorMessage: result.error_message });
                            this.setState({ showAlert: true });
                        }
                    }

                }
                else {
                    if (data[i].last_sale) {
                        data[i].last_sale = false;
                        let result = await this.handleDataSave(data[i]);
                        console.log(result);
                        if (!result.result) {
                            this.setState({ errorMessage: result.error_message });
                            this.setState({ showAlert: true });
                        }

                    }
                }
            };
        }
        else{
            console.log("Using user supplied last sale flag");
            for (var i = 0; i < data.length; i++) {
                if (i === this.state.last_sale_index) {
                    data[i].last_sale = true;
                   //this gets saved in the blur handling
                }
                else {
                    if (data[i].last_sale) {
                        data[i].last_sale = false;
                        const result = await this.handleDataSave(data[i]);
                        console.log(result);
                        if (!result.result) {
                            this.setState({ errorMessage: result.error_message });
                            this.setState({ showAlert: true });
                        }
                    }
                }
            };

        }
         
        this.props.updateTableState(data, this.state.dataSet);
        
        return;
    }



    handleSave = async (cellInfo, event) => {

        this.setState({ showAlert: false });
        if(this.props.controlType !== "table2"){
            await this.calculateLastSale();
        }

        let data = [...this.props.data];
        for (var i=0; i<data.length; i++){
            const validation = this.props.validateRelatedRecord(data[i], this.state.dataSet);
            console.log(validation[0]);
            if (validation[0] === true) {
                if (data[i].hasOwnProperty("modified")) {
                    if (data[i].modified === true) {
                        console.log(i);
                        //Save the data
                        if (!this.state.savingNewRecord) {
                            if (data[i].hasOwnProperty("new_record")) {
                                if (data[i].new_record === true) {
                                    this.setState({ savingNewRecord: true });
                                }
                            }
                            const result = await this.handleDataSave(data[i]);
                            if (result.result) {
                                data[i].modified = false;
                                if (data[i].hasOwnProperty("new_record")) {
                                    if (data[i].new_record === true) {

                                        data[i][this.state.dataSetPrimaryKey] = result.id;
                                        this.setState({ savingNewRecord: false });
                                        if (this.props.controlType=="table2"){
                                            this.props.getProperties({saleid: this.props.saleid});
                                        }

                                    }
                                    data[i].new_record = false;
                                }
                                                               
                            }
                            else {
                                this.setState({ errorMessage: result.error_message });
                                this.setState({ showAlert: true });
                            }
                        }
                    }

                }
            }
            else {
                this.setState({ errorMessage: validation[1] });
                this.setState({ showAlert: true });
            }
        }
        if (data[0].hasOwnProperty("property_key")) {
            data.sort(function (a, b) { 
                if (a.property_key===b.property_key){ 
                    return 0
                } 
                if(a.property_key < b.property_key ){return -1}else{return 1}
            });
        }   

        if (data[0].hasOwnProperty("sort_order")) {
            data.sort(function (a, b) { return a.sort_order - b.sort_order });
        }
        this.props.updateTableState(data, this.state.dataSet);


    }

    addRecord = async event => {
        let data = [...this.props.data];

        //Update the following with the minimum details to create a record (all not nulls populated)
        //Requires updating per dataset
        data.unshift({
            sale_id: this.props.saleid,
            property_id: null,
            property_key: "",
            last_sale: false,
            created_by: this.props.user,
            last_edited_by: this.props.user,
            new_record: true

        });
        this.props.updateTableState(data, this.state.dataSet);
    }

    renderEditable = cellInfo => {
        const cellValue = this.props.data[cellInfo.index][cellInfo.column.id];
        
        if (["last_sale"].indexOf(cellInfo.column.id) >= 0) {
            return (
                <Form.Check checked={cellValue}
                    onChange={this.handleCheckboxChange.bind(null, cellInfo)}
                    label=""
                    type="checkbox"
                    onBlur={this.handleSave.bind(null, cellInfo)}
                    
                />);
        }
        
        if (["withhold_flag"].indexOf(cellInfo.column.id) >= 0) {
            return (
                <Form.Check checked={cellValue}
                    
                    label=""
                    type="checkbox"
                    disabled
                    
                    
                />);
        }
        
            

        switch (typeof (cellValue)) {
            case "boolean":
                return (
                    <Form.Check checked={cellValue}
                        onChange={this.handleCheckboxChange.bind(null, cellInfo)}
                        label=""
                        type="checkbox"
                        onBlur={this.handleSave.bind(null, cellInfo)}
                        
                    />);

                    case "number":
                        return (
                            <input
                                onChange={this.handleNumberChange.bind(null, cellInfo)}
                                onBlur={this.handleSave.bind(null, cellInfo)}
                                type="number"
                                className="no-border form-control"
                                value={cellValue!==null? cellValue: " "}
        
                            />
                        );
        
                    default:
                        if (cellInfo.column.id.indexOf("date") >= 0) {
                            return (
                                <DatePicker
                                    selected={cellValue!==null?  new Date(cellValue):""}
                                    onChange={this.handleDateChange.bind(null, cellInfo)}
                                    onBlur={this.handleSave.bind(null, cellInfo)}
                                    dateFormat="dd/MM/yyyy"
                                    className="no-border form-control"
                                />);
                        }
                        else {
                            return (
                                <input
                                    onChange={this.handleInputChange.bind(null, cellInfo)}
                                    onBlur={this.handleSave.bind(null, cellInfo)}
                                    type="text"
                                    className="no-border form-control"
                                    value={cellValue!==null? cellValue:""}
        
                                />
                            );
                        }

        }
    }


    renderTable(data) {
        const columns = [

            {
                id: 'sale_id',
                Header: 'ID',
                maxWidth: 60,
                accessor: 'sale_id' ,
                Cell: e => <LinkContainer to={{pathname: `/sales/${e.value}` , state: {data: this.props.data.map(a => a.sale_id), primaryCategory: this.props.primaryCategory, propertyidlist: this.props.idList}}}><a> {e.value} </a></LinkContainer>

        }, {
                id: 'sale_date',
                Header: 'Sale Date',
                accessor: d => {
                    if (d.sale_date) {
                        return Moment(d.sale_date)
                            .local()
                            .format("DD-MM-YYYY")
                    }
                    else { return null }
                },
                maxWidth: 200,
                style: { textAlign: "center" }

            }, {
                id: 'contract_date',
                Header: 'Contract Date',
                accessor: d => {
                    if (d.contract_date) {
                        return Moment(d.contract_date)
                            .local()
                            .format("DD-MM-YYYY")
                    }
                    else { return null }
                },
                maxWidth: 200,
                style: { textAlign: "center" }

            }, {
                id: 'transfer_date',
                Header: 'Transfer Date',
                accessor: d => {
                    if (d.transfer_date) {
                        return Moment(d.transfer_date)
                            .local()
                            .format("DD-MM-YYYY")
                    }
                    else { return null }
                },
                maxWidth: 200,
                style: { textAlign: "center" }

            }, {
                id: 'sale_price',
                Header: 'Sale Price',
                accessor: 'sale_price',
                maxWidth: 200,
                style: { textAlign: "right" }

            }
            , {
                id: 'last_sale',
                Header: 'Last Sale',
                accessor: 'last_sale',
                Cell: this.renderEditable,
                maxWidth: 100,
                style: { textAlign: "center" }
            }
            , {
                id: 'appendix',
                Header: 'Appendix',
                accessor: 'appendix',
                maxWidth: 100,
                style: { textAlign: "right" }
            }, {
                id: 'income',
                Header: 'Income',
                accessor: 'income',
                maxWidth: 200,
                style: { textAlign: "right" }
            },
             {
    id: 'income_basis',
        Header: 'Income Basis',
        accessor: 'income_basis',
        maxWidth: 200,

}, {
                id: 'yield',
                Header: 'Yield',
                accessor: 'yield',
                style: { textAlign: "right" },
                maxWidth: 100,

            },
            
            {
                Header: '',
                accessor: 'property_sale_id',
                maxWidth: 65,
                Cell: row => <Button type="button" size="sm" variant="danger" onClick={(e) => this.handleDeleteRecord(row, e)}>Remove Property From Sale</Button>
            }
        ]

        if (!data) {
            return null
        }
        else {
            return (
                <ReactTable
                    data={data}
                    columns={columns}
                    defaultPageSize={10}
                    sortable={false}
                />
            )
        }



    }

    renderTable2(data) {
        const columns = [

             {
                id: 'property_key',
                Header: '',
                accessor: 'property_key',
                maxWidth: 120,
                Cell: e=> <LinkContainer to={ {pathname: `/properties/${e.original.property_key}`, state: {tab: "sales", data: this.props.propertyidlist.indexOf(e.original.property_key)>=0?this.props.propertyidlist:[] }}} ><Button  type="button" size="sm" variant="primary">Go to {e.original.property_key}</Button></LinkContainer>
            }, {
                id: 'property_key',
                Header: 'Cityscope Ref',
                accessor: 'property_key',
                maxWidth: 100,
                Cell:  this.renderEditable 
            }, {
                id: 'last_sale',
                Header: 'Last Sale',
                accessor: 'last_sale',                
                Cell: this.renderEditable,
                maxWidth: 40,
                style: { textAlign: "center" }
            }, {
                id: 'property_classification',
                Header: 'Classification',
                accessor: 'property_classification',
                maxWidth: 100,
                style:{ 'white-space': 'unset'}
            }
            , {
                id: 'year_built',
                Header: 'Year Built',
                accessor: 'year_built',
                maxWidth: 50,
            }
            , {
                id: 'site_area',
                Header: 'Site Area',
                accessor: 'site_area',
                maxWidth: 50,
                style: { textAlign: "right" },
                Footer:  <b>{this.props.areaSum} </b>                           
            }
            , {
                id: 'title_details',
                Header: 'Title',
                accessor: 'title_details',
                style:{ 'white-space': 'unset'}
            }
            , {
                id: 'withhold_flag',
                Header: 'Hold',
                accessor: 'withhold_flag',
                maxWidth: 50,
                Cell: this.renderEditable,
                style: { textAlign: "center" }
            }
            ,
            {
                Header: '',
                accessor: 'property_sale_id',
                maxWidth: 140,
                Cell: row => <Button type="button" size="sm" variant="danger" onClick={(e) => this.handleDeleteRecord(row, e)}>Remove Property</Button>
            }
        ]

        if (!data || data.length===0) {
            return null
        }
        else {
           
            
            
            return (
                <ReactTable
                    data={data}
                    columns={columns}
                    defaultPageSize={5}
                    sortable={false}
                />
            )
        }

    }

    renderTable4(data) {
        const columns = [

             {
                id: 'property_key',
                Header: '',
                accessor: 'property_key',
                maxWidth: 200,
                Cell: e=> <LinkContainer to={ {pathname: `/properties/${e.original.property_key}`, state: {tab: "sales"}}}><a>{e.original.property_key}</a></LinkContainer>
            }, {
                id: 'sale_date',
                Header: 'Sale Date',
                accessor: d => {
                    if (d.sale_date) {
                        return Moment(d.sale_date)
                            .local()
                            .format("DD-MM-YYYY")
                    }
                    else { return null }
                },
                maxWidth: 100
            }, {
                id: 'sale_price',
                Header: 'Sale Price',
                accessor: 'sale_price',
                maxWidth: 100,
                style: { textAlign: "right" }
            }, {
                id: 'property_classification',
                Header: 'Classification',
                accessor: 'property_classification',
                maxWidth: 150
            }
            , {
                id: 'year_built',
                Header: 'Year Built',
                accessor: 'year_built',
                maxWidth: 200,
            }
            
            , {
                id: 'title_details',
                Header: 'Title',
                accessor: 'title_details'
            }
           
        ]

        if (!data || data.length===0) {
            return null
        }
        else {
           
            
            
            return (
                <ReactTable
                    data={data}
                    columns={columns}
                    defaultPageSize={20}
                    sortable={false}
                />
            )
        }

    }



    //Modify the attribute shown in the list for each type of record
    
    renderList(data) {
        if (!data) {
            return null
        }
        else {
            return [{}].concat(data).map(
                (d, i) =>
                    i !== 0
                        ? <LinkContainer key={i} to={`/properties/${d.property_key}`}>
                            <ListGroup.Item key={i} as="a" header={d.property_key}>
                                {d.property_key}
                            </ListGroup.Item>
                        </LinkContainer>
                        : ""
            );
        }
    }

    
    renderComponent() {
        return (
            <div className="sales">
                <Modal show={this.state.showAlert} onHide={(e)=>{this.setState({showAlert: !this.state.showAlert})}} centered >
                    <Modal.Header closeButton> <Modal.Title>Uh Oh!</Modal.Title></Modal.Header>
                    <Modal.Body > <Alert variant="danger"  >{this.state.errorMessage}</Alert> </Modal.Body>
                </Modal>
                {(this.props.controlType === "table" || this.props.controlType === "table2") && <Row >
                    <Col className="text-right" >
                        {/*   <Button variant="secondary" size="sm" onClick={this.props.refreshDataSet}  >Refresh</Button>  */}
                        {this.props.controlType === "table" && <LinkContainer to={{pathname: `/properties/${this.props.propertykey}/sales/new?propertyid=${this.props.propertyid}` , state: { primaryCategory: this.props.primaryCategory, isUnit: this.props.IsUnit}}}><Button variant="secondary" size="sm">Add</Button></LinkContainer>}
                        {this.props.controlType === "table2"   && <Button variant="danger" disabled={!this.state.trust_proof} size="sm" onClick={this.props.removeHold}>Remove HOLD</Button> } {" "}
                        {this.props.controlType === "table2" && <Button variant="secondary" size="sm" onClick={this.addRecord}>Add</Button>}
                        
                    </Col>
                </Row>}
                    <Row className="show-Container">
                        <Col sm={12} md={12} lg={12}>
                        {!this.state.isLoading && this.props.controlType === "table" ? this.renderTable(this.props.data) : this.props.controlType === "table4" ? this.renderTable4(this.props.data) : this.props.controlType === "table2" ? this.renderTable2(this.props.data) : this.renderList(this.props.data)}
                        </Col>
                    </Row>
          

            </div>
        );
    }
  render() {
    return (

        <div className="SaleList">
            {this.props.isAuthenticated ? this.renderComponent() : console.log("error)")}
        </div>
    );
  }
}
